import { render, staticRenderFns } from "./Stuff.vue?vue&type=template&id=3acdeee4&scoped=true&"
import script from "./Stuff.vue?vue&type=script&lang=js&"
export * from "./Stuff.vue?vue&type=script&lang=js&"
import style0 from "./Stuff.vue?vue&type=style&index=0&id=3acdeee4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acdeee4",
  null
  
)

export default component.exports